function GooglePay({ dimensions, col = '#000' }) {
    const baseXml = `
      <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.24 10.28v3.44h4.92c-.2 1.28-.82 2.37-1.73 3.1l2.8 2.17c1.63-1.5 2.57-3.72 2.57-6.35 0-.61-.05-1.2-.16-1.77h-8.4v-.59z" fill=${`"${col}"`}/>
        <path d="M5.52 14.28l-.63.48-2.22 1.73C4.42 19.78 8.07 22 12.24 22c3.04 0 5.59-1 7.45-2.72l-2.8-2.17c-.77.52-1.76.83-2.88.91-2.31.15-4.33-1.26-5.14-3.22l-3.35 2.48z" fill=${`"${col}"`}/>
        <path d="M2.67 7.51C1.95 8.93 1.53 10.55 1.53 12.28s.42 3.35 1.14 4.77l3.35-2.58c-.22-.58-.35-1.21-.35-1.87s.13-1.29.35-1.87L2.67 7.51z" fill=${`"${col}"`}/>
        <path d="M12.24 5.02c1.62 0 3.08.56 4.22 1.65l3.14-3.14C17.79 1.74 15.27.56 12.24.56 8.07.56 4.42 2.78 2.67 6.07l3.35 2.58c.81-1.96 2.83-3.37 5.14-3.37l1.08.74z" fill=${`"${col}"`}/>
      </svg>
    `;

    return baseXml;
}

export default GooglePay;
